var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.988,
    height: 22.094,
    viewBox: "0 0 24.988 22.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -29.656)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 29.656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.819,29.656H1.168A1.17,1.17,0,0,0,0,30.825V50.58a1.17,1.17,0,0,0,1.168,1.169H23.819a1.171,1.171,0,0,0,1.169-1.169V30.825A1.171,1.171,0,0,0,23.819,29.656Zm.279,21.2H.888V34.888H24.1V50.86ZM24.1,34H.888V30.546H24.1V34Z",
    transform: "translate(0 -29.656)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.012,70.5a.7.7,0,1,0-.7-.7A.7.7,0,0,0,60.012,70.5Z",
    transform: "translate(-56.417 -67.169)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.809,70.495a.7.7,0,1,0-.7-.7A.7.7,0,0,0,129.809,70.495Z",
    transform: "translate(-122.808 -67.168)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.592,70.495a.7.7,0,1,0-.7-.7A.7.7,0,0,0,199.592,70.495Z",
    transform: "translate(-189.184 -67.168)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.673,235.179a.455.455,0,0,0,.629,0s3.017-3.011,3.07-3.066a.448.448,0,0,0,.059-.561c-.069-.072-1.913-1.922-3.129-3.14a.445.445,0,0,0-.628,0,.446.446,0,0,0,0,.628l2.754,2.754-2.756,2.756A.445.445,0,0,0,150.673,235.179Z",
    transform: "translate(-143.196 -218.588)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.6,354.937h4.343a.445.445,0,0,0,0-.89H243.6a.445.445,0,0,0,0,.89Z",
    transform: "translate(-231.29 -338.215)",
    fill: "#0080ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOs);
export default __webpack_public_path__ + "static/media/os.0bffa0cb.svg";
export { ForwardRef as ReactComponent };